<app-popover-dropdownlist
  #poddl
  [carregarDropdown]="carregarPopoverDropdownInventario">
</app-popover-dropdownlist>

<app-popup-detalhe-retirada
  #popupDetalheRetirada>
</app-popup-detalhe-retirada>

<form #f="ngForm" autocomplete="off" id="f">
    <div class="ui-g ui-fluid">
      <div class="ui-g-12" *ngIf="retirada.statusRetirada">
        <div class="card card-w-title ui-g">
          <table class="tabela-status-retirada">
            <!-- ID & tipo de BAIXA DE PRODUTO -->
            <tr>
              <td class="label-titulo ui-g-2">Id:</td>
              <td class="label-valor ui-g-3">{{ retirada.id }}</td>
              <td class="label-titulo ui-g-2" *ngIf="(retirada.dataRetirada && retirada.statusRetirada === 'BAIXADA')">Tipo de baixa:</td>
              <td class="label-valor ui-g-3" title="{{ retirada.tipoDeBaixaDeProduto?.descricao }}" *ngIf="(retirada.dataRetirada && retirada.statusRetirada === 'BAIXADA')">{{ retirada.tipoDeBaixaDeProduto?.nome }}</td>
            </tr>

            <!-- status -->
            <tr>
              <td class="label-titulo ui-g-2">Status:</td>
              <td class="ui-g-3"><b><label [class]='cssClassStatusRetirada'>{{retirada.statusRetirada}}</label></b></td>

              <td class="label-titulo ui-g-2">Unidade:</td>
              <td class="label-valor ui-g-5" >{{retirada.unidade?.nome}}</td>
            </tr>

            <tr>
              <td class="label-titulo ui-g-2">Solicitada em:</td>
              <td class="label-valor ui-g-3">{{retirada.dataSolicitacao | myDatetime}}</td>
              <td class="label-titulo ui-g-2">Solicitada por:</td>
              <td class="label-valor ui-g-5">{{retirada.usuarioSolicitacao ? retirada.usuarioSolicitacao.nome : ''}}</td>
            </tr>

            <tr *ngIf="retirada.dataAprovacao">
              <td class="label-titulo ui-g-2" *ngIf="retirada.statusRetirada === 'REPROVADA'; else templateAprovada">Reprovada em:</td>
              <ng-template #templateAprovada>
                <td class="label-titulo ui-g-2">Aprovada em:</td>
              </ng-template>
              <td class="label-valor ui-g-3">{{retirada.dataAprovacao | myDatetime}}</td>
              <td class="label-titulo ui-g-2" *ngIf="retirada.statusRetirada === 'REPROVADA'; else templateAprovada">Reprovada por:</td>
              <ng-template #templateAprovada>
                <td class="label-titulo ui-g-2">Aprovada por:</td>
              </ng-template>
              <td class="label-valor ui-g-3">{{retirada.usuarioAprovacao?.nome}}</td>
            </tr>

            <!-- status RETIRADA -->
            <tr *ngIf="retirada.dataRetirada && retirada.statusRetirada !== 'BAIXADA'">
              <td class="label-titulo ui-g-2">Retirada em:</td>
              <td class="label-valor ui-g-3">{{retirada.dataRetirada | myDatetime}}</td>
              <td class="label-titulo ui-g-2">Retirada por:</td>
              <td class="label-valor ui-g-3">{{retirada.usuarioRetirada?.nome}}</td>
            </tr>

            <!-- status BAIXADA -->
            <tr *ngIf="retirada.dataRetirada && retirada.statusRetirada === 'BAIXADA'">
              <td class="label-titulo ui-g-2">Baixado em:</td>
              <td class="label-valor ui-g-3">{{retirada.dataRetirada | myDatetime}}</td>
              <td class="label-titulo ui-g-2">Baixado por:</td>
              <td class="label-valor ui-g-3">{{retirada.usuarioRetirada?.nome}}</td>
            </tr>

            <tr *ngIf="retirada.statusRetirada">
              <td colspan="4" class="container-observacao">
                <label class="label-titulo titulo-observacao">Observação: </label>
                <div class="label-valor valor-observacao">{{ retirada.observacao }}</div>
              </td>
            </tr>

          </table>
        </div>
      </div>

      <div class="ui-g-12 ui-lg-12">

        <!-- BLOCO 1 . HEADER -->
        <div class="card card-w-title" *ngIf="!retirada.statusRetirada">
          <div class="ui-g form-group">

            <!-- unidade -->
            <div class="ui-g-4">
              <app-autocomplete-unidade
                [obrigatorio]="true"
                [bloqueado]="unidadeBloqueada || formDisabled"
                #autocompleteUnidade>
              </app-autocomplete-unidade>
            </div>

            <!-- solicitante -->
            <div class="ui-g-4">
              <span class="md-inputfield">
                <p-autoComplete
                    name="autocompleteUsuario"
                    field="nome"
                    [(ngModel)]="usuarioSelecionado"
                    [suggestions]="resultsetUsuarios"
                    [dropdown]="true"
                    [size]="resultsetMaxSize"
                    [forceSelection]="true"
                    [tabindex]=1
                    [required]="true"
                    [disabled]="true"
                    [readonly]="true"
                    (completeMethod)="searchUsuario($event)"
                    (onSelect)="onSelectUsuario($event)"
                    (onClear)="onClearUsuario()">
                </p-autoComplete>
                <label>Solicitante</label>
              </span>
            </div>

            <!-- tipo de baixa -->
            <div class="ui-g-4" *ngIf="(tiposDeBaixaDeProduto?.length > 0);else containerSemTipoDeBaixaCadastrado">
              <span class="md-inputfield">
                <p-dropdown
                  name="tipoDeBaixaDeProduto"
                  required="true"
                  [options]="tiposDeBaixaDeProduto"
                  optionLabel="nome"
                  [autoDisplayFirst]="false"
                  [(ngModel)]="tipoDeBaixaDeProdutoSelecionado">
                </p-dropdown>
                <label>Tipo de baixa</label>
              </span>
            </div>
            <ng-template #containerSemTipoDeBaixaCadastrado>
              <div class="ui-g-4" *ngIf="preparandoBaixa">
                <label class="tag"
                  title="Você pode cadastrar no menu Farmácia / Configurações / Tipo de baixa">Nenhum tipo de baixa cadastrado</label>
              </div>
            </ng-template>

            <div class="ui-g-12" >
              <span class="md-inputfield">
                Observação
                <textarea
                  pInputTextarea
                  name="observacao"
                  [(ngModel)]="retirada.observacao">
                </textarea>
              </span>
            </div>
          </div>
        </div>

        <!-- BLOCO 2 . PRODUTOS -->
        <div class="card card-w-title" *ngIf="exibirFormularioInserirProduto">
          <div class="ui-g form-group">
            <div class="ui-g-4">
              <p-dropdown
                name="tipoProduto"
                tabindex="2"
                [(ngModel)]="selectedTipoProduto"
                [options]="tipoProduto"
                [disabled]="formDisabled"
                [autofocus]="true"
                [autoWidth]="false"
                (onChange)="onChangeTipoProduto($event)"
                required>
              </p-dropdown>
            </div>

            <!-- FIXME: O autocomplete abaixo deve pesquisar apenas nos Inventários da Unidade Selecionada
                        atualmente está pesquisando em Todos Os Inventários-->
            <div class="ui-g-6">
              <span class="md-inputfield" title="Produtos válidos nos Inventários">
                <p-autoComplete
                  name="autocompleteProduto"
                  inputId="produtoSelecionado"
                  field="label"
                  [(ngModel)]="produtoSelecionado"
                  [suggestions]="resultsetProdutos"
                  [dropdown]="true"
                  [size]="resultsetProdutosMaxSize"
                  [forceSelection]="true"
                  [tabindex]=3
                  [required]=true
                  [disabled]="formDisabled"
                  (completeMethod)="searchProduto($event)"
                  (onSelect)="onSelectProduto($event)"
                  (onClear)="onClearProduto($value)">
                </p-autoComplete>
                <label>Produto</label>
              </span>
            </div>

            <div class="ui-g-2">
              <span class="md-inputfield">
                <input type="text"
                  name="quantidade"
                  style="text-align: right"
                  [(ngModel)]="quantidade"
                  tabindex="4"
                  [disabled]="formDisabled"
                  (keypress)="apenasInteiros($event)"
                  (keyup.enter)="inserirItemRetirada($event);"
                  required pInputText>
                <label>Quant.</label>
              </span>
            </div>

            <div class="ui-g-12" align="right" style="padding-right: 2%;">
              <p-button label="Inserir" (click)="inserirItemRetirada($event)" [disabled]="formDisabled || !f.form.valid"></p-button>
            </div>
          </div>
        </div>


        <!-- <br /> -->
        <!-- BLOCO 3 . LISTA -->
        <div class="card card-w-title">
          <app-lista
            #app_lista
            [controller]="this"
            [noServiceAndObservable]="true"
            [tipoLista]="'item-retirada'"
            [esconderPaginacao]="true"
            [exibirLegenda]="false">
          </app-lista>
        </div>
      </div>
    </div>
    </form>
